import { useState, type FormEvent } from 'react'
import { screenerClient } from '../../api'
import type { AdminRecord } from '../../api/types'

/** Equivalent of legacy `SearchEventLogComponent` (audit §3/§4 — admin
 * event-log search, `GET /admin/log/events`). */
export function AdminLogPage() {
  const [email, setEmail] = useState('')
  const [page, setPage] = useState(1)
  const [result, setResult] = useState<AdminRecord | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function search(nextPage: number) {
    setLoading(true)
    setError(null)
    try {
      const data = await screenerClient.admin.searchEventLog({ email: email || undefined, page: nextPage, pageSize: 50 })
      setResult(data)
      setPage(nextPage)
    } catch {
      setError('Could not load the event log.')
    } finally {
      setLoading(false)
    }
  }

  function handleSubmit(event: FormEvent) {
    event.preventDefault()
    void search(1)
  }

  return (
    <div>
      <h1>Admin — event log</h1>
      <form className="screener-form" onSubmit={handleSubmit}>
        <label>
          User email (optional)
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
        </label>
        <button type="submit" disabled={loading}>
          {loading ? 'Searching…' : 'Search'}
        </button>
      </form>
      {error && <p role="alert">{error}</p>}
      {result != null && <pre>{JSON.stringify(result, null, 2)}</pre>}
      {result != null && (
        <div className="screener-actions">
          <button type="button" disabled={page <= 1} onClick={() => void search(page - 1)}>
            Previous page
          </button>
          <span>Page {page}</span>
          <button type="button" onClick={() => void search(page + 1)}>
            Next page
          </button>
        </div>
      )}
    </div>
  )
}
